import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetUnitCostNodesRequest extends BaseServiceRequest {
  constructor(portfolioID, oid, startdate, enddate, getlong, getshort, currcode) {
    super();
    super.addRequestUri("getunitcostnodes");
    super.setContent({
      "pids": portfolioID.toString(),
      "oid": oid,
      "startdate": startdate,
      "enddate": enddate,
      "getlong": getlong,
      "getshort": getshort,
      "currcode": currcode,
    });
  }

  getMethod() {
    return HttpMethodType.POST;
  }

  getSubSystem() {
    return SubSystemType.ACCOUNT_ANALYZER;
  }

  // getMessageName() {
  //   return "UnitCostNodesRequest";
  // }
}

export default GetUnitCostNodesRequest;
